import { Avatar, TableRow } from '@mui/material';
import { StyledTableCell } from '../../../../../../shared/components/CustomTable/Styled';
import { formatTimestamp } from '../../../../../ProductOrder/detail/EventLog';
import { stringAvatar } from '../../../../../UserList/Content/UserTable';
import Status from '../../../../../../shared/components/Status';
import { StyledNavLink } from '../../../../../../shared/styled/TableStyles';

const HistoryTableRows = ({ item }: { item: any }) => {
    const textCategory = item.transaction_type === 'OUT' ? 'Xuất kho' : 'Nhập kho';
    const colorCategory = item.transaction_type === 'OUT' ? 'INFO' : 'WARNING';

    return (
        <TableRow>
            <StyledTableCell align="left">
                {formatTimestamp(item.transaction_date)}
            </StyledTableCell>
            <StyledTableCell align="left">{item.quantity}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={colorCategory}
                    text={textCategory}
                    width={'72px'}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.content_type.toLowerCase() === 'productorder' && (
                    <StyledNavLink to={`/product-orders/${item.object_id}`}>
                        {item.object_name}
                    </StyledNavLink>
                )}
            </StyledTableCell>
            <StyledTableCell align="left">
                <Avatar
                    {...stringAvatar(item.performed_by.username)}
                    sx={{ width: '32px', height: '32px', fontSize: '16px' }}
                />
            </StyledTableCell>
        </TableRow>
    );
};

export default HistoryTableRows;
